import React, { Component } from 'react';
import { connect} from "remx";

import authStore from "../../stores/auth";
import dataStore from "../../stores/data";
import broker from '../../utils/broker';

class Sidebar extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            data_pelanggan: [],
            sort_pelanggan: [],
            data_kategori : [],
            id_kategori : null,
            nama_kategori : null,
            color_kategori: null,
            first_label : '',
            search_query: ''
        }
        this.getDataPelanggan = this.getDataPelanggan.bind(this);
        this.setFormView = this.setFormView.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    getDataPelanggan(){
        broker.fetch.get(`/data/kategori/${this.props.data_kategori_per.id_kategori}/pelanggan`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                this.setState({data_pelanggan : data.data}, function(){
                    if (data.data[0]){
                        dataStore.setters.setDataPelangganId(data.data[0].id);
                    } else {
                        dataStore.setters.setDataPelangganId('');
                        dataStore.setters.setDataPelanggan({});
                    }
                });
            } else {

            }
        }).catch(err => {
            
        });
    }

    getDataKategori(){
        broker.fetch.get(`/data/user/${this.props.user.id}/kategori`)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                dataStore.setters.setDataKategori(data.data);
                if (!this.props.data_kategori_per.id_kategori) {
                    dataStore.setters.setDataKategoriPer({id_kategori : data.data[0].id, 
                                                        nama_kategori : data.data[0].nama_keterangan, 
                                                        color_kategori : data.data[0].color0
                    });  
                }
            } else {

            }
        }).catch(err => {
            
        });
    }

    componentDidMount(){
        this.getDataKategori();
        this.getDataPelanggan();
    }
    

    componentDidUpdate(prevProps, prevState) {
        if(this.props.data_kategori_per !== prevProps.data_kategori_per){
            this.getDataPelanggan(); 
        }

        if(this.state.data_pelanggan !== prevState.data_pelanggan){
            var data_pelanggan = this.state.data_pelanggan;
            // var sort_pelanggan = data_pelanggan.sort(function(a,b){
            //     var a1 = a.no_urut_pelanggan;
            //     var b1 = b.no_urut_pelanggan;
            //     var len = Math.max(a1.length, b1.length);
                
            //     for(var i = 0; i< len; i++){
            //       var _a = +a1[i] || 0;
            //       var _b = +b1[i] || 0;
            //       if(_a === _b) continue;
            //       else return _a > _b ? 1 : -1
            //     }
            //     return 0;
            // })

            this.setState({sort_pelanggan: data_pelanggan});
        }
    }

    setDataKategori(id, nama, color){
        dataStore.setters.setDataKategoriPer({id_kategori : id, nama_kategori :nama, color_kategori :color});  
    }

    setDataPelanggan(id){
        dataStore.setters.setDataPelangganId(id);
    }

    setFormView(e, view){
        e.preventDefault();
        dataStore.setters.setDataFormView(view)
    }

    handleSearch(event){
       var query = event.target.value;
       if (query.length > 3) {
           var pelanggan = this.state.sort_pelanggan;
           var filter = pelanggan.filter(o => Object.keys(o).some(k => o.nama_pelanggan.toLowerCase().includes(query.toLowerCase())));
           this.setState({sort_pelanggan : filter});
           
       } else if (query.length < 3) {
            var data_pelanggan = this.state.data_pelanggan;
            var sort_pelanggan = data_pelanggan.sort(function(a,b){
                var a1 = a.no_urut_pelanggan;
                var b1 = b.no_urut_pelanggan;
                var len = Math.max(a1.length, b1.length);
                
                for(var i = 0; i< len; i++){
                var _a = +a1[i] || 0;
                var _b = +b1[i] || 0;
                if(_a === _b) continue;
                else return _a > _b ? 1 : -1
                }
                return 0;
            })

            this.setState({sort_pelanggan: sort_pelanggan});
       }
    }

    render(){
        let nama_klasifikasi = "";
        return(
            <React.Fragment>
                 <div className="contact-navleft">
                    <nav className="nav flex-column">
                        <a href="#!" onClick={(e) => this.setFormView(e, 'resume')} 
                            className={"nav-link" + (this.props.form_view === 'resume' ? " active" : "")} data-toggle="tab">
                            <span data-toggle="tooltip" title="Resume Pekerjaan" data-placement="right"><i className="fas fa-chart-pie fa-lg"></i></span>
                        </a>
                        <a href="#!"  onClick={(e) => this.setFormView(e, 'data_traffic')} 
                            className={"nav-link" + (this.props.form_view === 'data_traffic' ? " active" : "")} data-toggle="tab">
                            <span data-toggle="tooltip" title="Data Traffic" data-placement="right"><i className="far fa-sticky-note fa-lg"></i></span>
                        </a>
                        <a href="#!" onClick={(e) => this.setFormView(e, 'live_graphic')} 
                            className={"nav-link" + (this.props.form_view === 'live_graphic' ? " active" : "")} data-toggle="tab">
                            <span data-toggle="tooltip" title="Live Graphic" data-placement="right"><i className="fas fa-chart-line fa-lg"></i></span>
                        </a>
                        <a href="#!" onClick={(e) => this.setFormView(e, 'data_down')} 
                            className={"nav-link" + (this.props.form_view === 'data_down' ? " active" : "")} data-toggle="tab">
                            <span data-toggle="tooltip" title="Data Down" data-placement="right"><i className="far fa-thumbs-down fa-lg"></i></span>
                        </a>
                        <a href="#!" onClick={(e) => this.setFormView(e, 'map_pekerjaan')} 
                            className={"nav-link" + (this.props.form_view === 'map_pekerjaan' ? " active" : "")} data-toggle="tab">
                            <span data-toggle="tooltip" title="Map Pekerjaan" data-placement="right"><i className="fas fa-map-marker-alt fa-lg"></i></span>
                        </a>
                    </nav>
                </div>
                <div className="contact-sidebar">
                    <div className="chat-sidebar-header">
                        <a href="#" data-toggle="dropdown" className="dropdown-link">
                            <div className="d-flex align-items-center">
                                <div className="avatar avatar-sm mg-r-8"><span className="avatar-initial rounded-circle" style={{backgroundColor : this.props.data_kategori_per.color_kategori}}>{(this.props.data_kategori_per.nama_kategori) ? this.props.data_kategori_per.nama_kategori.charAt(0) : ''}</span></div>
                                <span className="tx-color-01 tx-semibold">{(this.props.data_kategori_per.nama_kategori) ? this.props.data_kategori_per.nama_kategori.substring(0, 25) : ''}</span>
                            </div>
                            <span><i data-feather="chevron-down"></i></span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                            {(this.props.data_kategori) &&
                                this.props.data_kategori.map((data, i) => {
                                    return <a key={i} onClick={() => this.setDataKategori(data.id, data.nama_keterangan, data.color) } className="cursor-pointer dropdown-item">
                                                    <i data-feather="user-plus"></i>{data.nama_keterangan.substring(0, 25) + (data.nama_keterangan.length > 25 ? '.....' : '')}
                                        </a>})
                            }
                        </div>
                    </div>
                    <div className="contact-sidebar-body">
                        <div>
                            <input type="text" className="form-control input-line-style" 
                                onChange={this.handleSearch} 
                                placeholder="Search......." 
                                // value={this.state.search_query}
                            />
                        </div>
                        <div className="tab-content">
                            <div id="tabContact" className="tab-pane fade active show">
                                <div className="pd-y-20 pd-x-10 contact-list">
                                    <p className="tx-10 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10 mg-b-10">{(this.state.data_pelanggan[0]) ? this.state.data_pelanggan[0].klasifikasi : ''}</p>
                                    {(this.state.sort_pelanggan) &&
                                        this.state.sort_pelanggan.map((data, i) => {
                                            if (nama_klasifikasi !== data.klasifikasi && i !== 0) {
                                                nama_klasifikasi = data.klasifikasi
                                                return <React.Fragment key={i}>
                                                            <label className="contact-list-divider"></label>
                                                            <p className="tx-10 tx-uppercase tx-medium tx-color-03 tx-sans tx-spacing-1 pd-l-10 mg-b-10">{data.klasifikasi}</p>
                                                            <div className={"media " +((this.props.pelanggan_id === data.id) ? ' active ' : '')} key={i} onClick={() => this.setDataPelanggan(data.id)}>
                                                                <div className="avatar avatar-sm"><span className="avatar-initial rounded-circle" style={{backgroundColor: data.color}}>{(data.nama_pelanggan) ? data.nama_pelanggan.charAt(0) : ''}</span></div>
                                                                <div className="media-body mg-l-10 cursor-pointer">
                                                                    <h6 className="tx-13 mg-b-3">{data.nama_pelanggan_ + (data.nama_pelanggan_.length > 20 ? '.....' : '')}</h6>
                                                                    <span className="tx-12">{data.sub_klasifikasi}</span>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>

                                            } else {
                                                nama_klasifikasi = data.klasifikasi

                                                return <div className={"media " +((this.props.pelanggan_id === data.id) ? ' active ' : '')} key={i} onClick={() => this.setDataPelanggan(data.id)}>
                                                        <div className="avatar avatar-sm"><span className="avatar-initial rounded-circle" style={{backgroundColor: data.color}}>{(data.nama_pelanggan) ? data.nama_pelanggan.charAt(0) : ''}</span></div>
                                                        <div className="media-body mg-l-10 cursor-pointer">
                                                            <h6 className="tx-13 mg-b-3">{data.nama_pelanggan_ + (data.nama_pelanggan_.length > 24 ? '.....' : '')}</h6>
                                                            <span className="tx-12">{data.sub_klasifikasi}</span>
                                                        </div>
                                                    </div>
                                            }
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </React.Fragment>
        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        kategori_id : dataStore.getters.getDataKategoriId(),
        form_view : dataStore.getters.getDataFormView(),
        data_kategori : dataStore.getters.getDataKategori(),
        data_kategori_per : dataStore.getters.getDataKategoriPer(),
    }
}

export default connect(mapStateToProps)(Sidebar);